module.exports = require('./helpers/bundle-url').getBundleURL('f34WS') + "logo.c51670a8.svg";